import { RCCallout, RCButtonLink } from '@reverbdotcom/cadence/components';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import React from 'react';
import { WarningIcon } from '@reverbdotcom/cadence/icons/react';

// The legacy BannerType (status colors) maps 1:1 onto RCCallout utility variants.
const VARIANT_BY_BANNER_TYPE = {
  info: 'info-ultralight',
  warning: 'notice-ultralight',
  error: 'urgent-ultralight',
  success: 'success-ultralight',
  highlight: 'loud-ultralight',
  plain: 'neutral-ultralight',
} as const;

export interface Props {
  message: string;
  headline: string;
  buttonLinkPath?: string;
  buttonText?: string;
  hideIcon?: boolean;
  bannerType?: keyof typeof VARIANT_BY_BANNER_TYPE;
}

export function TaxInformationBanner({
  message,
  headline,
  buttonLinkPath = '/my/selling/tax_id',
  buttonText = undefined,
  hideIcon = false,
  bannerType = 'info',
}: Props) {

  return (
    <RCCallout
      themeType="utility"
      variant={VARIANT_BY_BANNER_TYPE[bannerType]}
      icon={hideIcon ? undefined : <WarningIcon />}
      title={headline}
      cta={buttonText ? (
        <RCButtonLink
          variant="filled"
          renderLink={c => <CoreLink to={buttonLinkPath}>{c}</CoreLink>}
        >
          {buttonText}
        </RCButtonLink>
      ) : undefined}
    >
      <p>{message}</p>
    </RCCallout>
  );
}

export default TaxInformationBanner;
